export default "__VITE_ASSET__QvUjCfBh__"